module.exports = __webpack_public_path__ + "static/media/insurance.dcafbfef.svg";